import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list"]

  filter(event) {
    const query = event.target.value.trim().toLowerCase()
    this.listTarget.querySelectorAll("[data-people-filter-name]").forEach((person) => {
      person.hidden = !person.dataset.peopleFilterName.includes(query)
    })
  }
}
